module.exports = __webpack_public_path__ + "static/media/globas_trimmed.65de8abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/globas_trimmed.png
// module id = 284
// module chunks = 0